/**
 * Copied from index page
 * real author @dzitnik
 * @author @dzitnik
 */
import { memo, useCallback } from 'react';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import { H4 } from 'UIComponents/elements/headings';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error type dependency error
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PRODUCT_VIEWS_TOUR_SETTING = 'productViewsTourSeen';

/*
 * Temporarily copied from crm_data/static/js/settings/LocalSettings
 */
const LOCAL_SETTINGS_PREFIX = 'LocalSettings:Sales:';
function makePrefixedKey(key) {
  return LOCAL_SETTINGS_PREFIX + key;
}
function getFrom(storage, key) {
  try {
    const entry = storage[makePrefixedKey(key)];
    if (entry === undefined) {
      return entry;
    }
    return JSON.parse(entry);
  } catch (error) {
    return undefined;
  }
}
function setFrom(storage, key, value) {
  try {
    storage[makePrefixedKey(key)] = JSON.stringify(value);
    return value;
  } catch (error) {
    return undefined;
  }
}

/*
 * End from crm_data/static/js/settings/LocalSettings
 */

function ProductsViewTourPopover({
  children
}) {
  const hasSeenProductViewTour = getFrom(localStorage, PRODUCT_VIEWS_TOUR_SETTING);
  const handleClose = useCallback(() => {
    setFrom(localStorage, PRODUCT_VIEWS_TOUR_SETTING, true);
  }, []);
  return /*#__PURE__*/_jsx(UIPopover, {
    use: "shepherd",
    placement: "bottom",
    "data-test-id": "products-view-tour-popover",
    width: 350,
    showCloseButton: true,
    defaultOpen: !hasSeenProductViewTour,
    animateOnMount: true,
    onCloseStart: handleClose,
    content: {
      header: /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "viewsManagement.tours.products.addViewTab.header"
        })
      }),
      body: /*#__PURE__*/_jsxs(UIFlex, {
        direction: "column",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "viewsManagement.tours.products.addViewTab.body"
        }), /*#__PURE__*/_jsx(KnowledgeBaseButton, {
          url: "https://knowledge.hubspot.com/products/how-do-i-use-products"
        })]
      })
    },
    children: children
  });
}
export default /*#__PURE__*/memo(ProductsViewTourPopover);